var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.332 8.66669C11.332 8.9319 11.2267 9.18626 11.0391 9.37379C10.8516 9.56133 10.5972 9.66669 10.332 9.66669C10.0668 9.66669 9.81246 9.56133 9.62492 9.37379C9.43739 9.18626 9.33203 8.9319 9.33203 8.66669C9.33203 8.40147 9.43739 8.14712 9.62492 7.95958C9.81246 7.77204 10.0668 7.66669 10.332 7.66669C10.5972 7.66669 10.8516 7.77204 11.0391 7.95958C11.2267 8.14712 11.332 8.40147 11.332 8.66669Z",
    fill: "#323232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.20867 3.81868L10.542 1.72334C10.7901 1.65245 11.0512 1.64011 11.3048 1.68729C11.5585 1.73448 11.7977 1.83991 12.0037 1.99527C12.2096 2.15064 12.3767 2.3517 12.4918 2.58262C12.6068 2.81354 12.6667 3.06802 12.6667 3.32601V4.00001C13.0203 4.00001 13.3594 4.14049 13.6095 4.39054C13.8595 4.64058 14 4.97972 14 5.33334V12C14 12.3536 13.8595 12.6928 13.6095 12.9428C13.3594 13.1929 13.0203 13.3333 12.6667 13.3333H3.33333C2.97971 13.3333 2.64057 13.1929 2.39052 12.9428C2.14048 12.6928 2 12.3536 2 12V5.33334C2 4.63668 2.55667 4.00468 3.20867 3.81868ZM10.9087 3.00534C10.9582 2.99123 11.0104 2.98879 11.061 2.99822C11.1117 3.00765 11.1595 3.0287 11.2006 3.05971C11.2418 3.09071 11.2752 3.13084 11.2982 3.17693C11.3212 3.22302 11.3332 3.27382 11.3333 3.32534V4.00001H7.42667L10.9087 3.00534ZM3.33333 5.33334H12.6667V12H3.33333V5.33334Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.2b107f4386c8ae153feb36f3984891b1.svg";
export { ForwardRef as ReactComponent };